module.exports = __webpack_public_path__ + "img/mau6-trang-suc-75x10mm.40036c23.jpg";